import React from 'react';
import { useNavigate } from 'react-router-dom';

const Hero = () => {
  const navigate = useNavigate();

  return (
    <section className="hero-section">
      <div className="container hero-container">
        
        {/* Left Side: Text & Buttons */}
        <div className="hero-text-content">
          <div className="hero-badge">
            ✨ Authentic Since 2022
          </div>
          
          <h1 className="hero-title">
            Experience<br/>
            <span className="hero-title-highlight">Authentic Chai</span>
          </h1>
          
          <p className="hero-description">
            Premium tea premixes crafted with quality ingredients. Bring the authentic taste of Indian chai to your home.
          </p>
          
          <div className="hero-buttons">
            {/* Replaced Zomato link with About Us button */}
            <button onClick={() => navigate('/about')} className="btn-primary">
              About Us
            </button>
            <button onClick={() => navigate('/products')} className="btn-outline">
              View Products
            </button>
          </div>
        </div>

        {/* Right Side: Image & Floating Card */}
        <div className="hero-visual">
          <div className="hero-image-wrapper">
            <img src="https://images.pexels.com/photos/34324342/pexels-photo-34324342.jpeg" alt="Pouring Chai" className="hero-main-img" />
            
            <div className="floating-card">
              <p className="fc-subtitle">Customer Favorite</p>
              <p className="fc-title">Masala Chai</p>
              <div className="fc-stars">★★★★★</div>
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Hero;